export default function buildCar(values) {
    const {
        year,
        make,
        serie,
        fuel,
        displacement,
    } = values || {};

    const columns = [
        {header: 'Год вып.', value: year},
        {header: 'Марка', value: make?.make},
        {header: 'Модель', value: serie?.serie},
        {header: 'Тип топлива', value: fuel?.fuelName},
        {
            header: 'Объем двигателя',
            value:
                displacement && displacement.displacement !== '-'
                    ? ' ' + Number(displacement.displacement).toFixed(1)
                    : displacement?.displacement,
        },

    ];

    const filteredColumns = columns.filter(
        ({value}) => value !== null && value !== undefined && value !== ''
    );
    const headers = filteredColumns.map(col => ({text: col.header}));
    const row = filteredColumns.map(col => col.value);

    return {
        margin: [0, 0, 0, 10],
        table: {
            headerRows: 1,
            body: [headers, row],
        },
    };
}